/**
 * Browserschluessel tragen seit dem 08.09.2026 das Praefix `forq.` -- vorher `forq-next.`.
 *
 * Wer FORQ schon benutzt hat, hat in seinem Browser eine Mandantenwahl, Navigationsfavoriten,
 * abgeschaltete Funktionen und weggeklickte Systemmeldungen stehen. Ein blosses Umbenennen der
 * Konstanten haette all das stillschweigend entwertet: die Anwendung faende unter dem neuen Namen
 * nichts und faenge bei jedem von vorn an. Das waere kein Fehler, den jemand meldet -- es waere
 * einfach jeden Morgen ein bisschen falsch.
 *
 * Deshalb dieser Umzug beim Start: jeder Schluessel mit dem alten Praefix wird unter dem neuen
 * angelegt. Der alte bleibt vorerst LIEGEN -- absichtlich: wird eine Auslieferung zurueckgenommen
 * (Cloudflare stellt den vorigen Bau wieder her), liest die aeltere Fassung wieder den alten
 * Schluessel, und niemand steht ohne seine Einstellungen da. Das Aufraeumen (removeItem) gehoert
 * in eine spaetere Fassung, wenn kein Rueckschritt mehr in Frage kommt.
 *
 * Bewusst NICHT umbenannt wird alles, wo der Name eine Kennung nach aussen ist -- das
 * Datenbankschema `forq_next_preview` und die Adresse forq-next.pages.dev. Siehe
 * `docs/ARBEITSSTAND.md`.
 */

const legacyPrefix = 'forq-next.';
const currentPrefix = 'forq.';

/**
 * Legt jeden Schluessel mit dem alten Praefix unter dem neuen an. Ein bereits vorhandener neuer
 * Schluessel gewinnt: er ist der juengere Stand. Der alte wird nicht geloescht (siehe oben).
 *
 * Faellt der Speicher aus (privates Fenster, gesperrte Cookies), passiert nichts weiter -- die
 * Anwendung laeuft dann eben mit ihren Standardwerten, so wie sie es ohne Speicher immer tut.
 */
export function migrateLegacyStorageKeys(storage?: Storage): void {
  try {
    // Der Zugriff auf localStorage gehoert INNERHALB des try: in einem Browser mit gesperrten
    // Cookies wirft schon das Lesen der Eigenschaft. Stuende er im Standardwert des Parameters,
    // wuerde er ausserhalb ausgewertet -- und ein einziger Wurf haette den Start der ganzen
    // Anwendung verhindert, wegen einer Aufraeumarbeit.
    const speicher = storage ?? globalThis.localStorage;
    if (!speicher) return;

    // Erst sammeln, dann schreiben: die Schleife laeuft ueber Indizes, und ein Schreiben
    // waehrenddessen kann sie verschieben.
    const alteSchluessel: string[] = [];
    for (let index = 0; index < speicher.length; index += 1) {
      const key = speicher.key(index);
      if (key?.startsWith(legacyPrefix)) alteSchluessel.push(key);
    }

    for (const alterSchluessel of alteSchluessel) {
      const neuerSchluessel = `${currentPrefix}${alterSchluessel.slice(legacyPrefix.length)}`;
      const wert = speicher.getItem(alterSchluessel);
      // Ein schon vorhandener neuer Schluessel gewinnt: er ist der juengere Stand.
      if (wert !== null && speicher.getItem(neuerSchluessel) === null) {
        speicher.setItem(neuerSchluessel, wert);
      }
    }
  } catch {
    // Kein Speicher, kein Umzug. Das ist der harmlose Ausgang.
  }
}
